(ns ycweb.app.website.help.categories
  (:require
   [rum.core :as rum]
   [ycweb.app.website.website :as website]
   [util.string :as ustr]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.help.common :as common]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]
   [clojure.string :as str]))

(rum/defc help-category < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        {:help-category/keys [id articles] :ent/keys [display-name]}
        (cmn/curact process-atom :help-category)]
    (web-common/set-meta-title! (str "Yuppiechef Help - FAQs - " display-name))
    [:div
     (common/help-center-banner app-atom {})
     (common/breadcrumbs app-atom
       {:id id
        :display-name display-name})

     [:div
      {:class (u/bem :yc-section [:large])}
      [:div
       {:class (u/bem :yc-section [:standard])}
       (headings/heading display-name {:type :h2 :size :medium :center true})]

      (into
        [:div]
        (concat
          [(map
             (fn [{:article/keys [id body url-name] :as article}]
               (when-not (str/blank? (:ent/display-name article))
                 [:article.help-center-result
                  [:a
                   (merge
                     (urlstate/href-props app-atom "help" "article" {:id id :name url-name})
                     {:class (u/bem :text-card [:medium] :card :block-link)})
                   (headings/heading (:ent/display-name article)
                     {:type :h3
                      :size :tiny
                      :dangerouslySetInnerHTML? true
                      :class :help-center-result__title})
                   [:p.yc-paragraph.help-center-result__description
                    [:span
                     {:dangerouslySetInnerHTML
                      {:__html (ustr/prune body 145)}}]
                    " "
                    [:span.text-link "View more."]]
                   [:small.help-center-result__category
                    (str "In " display-name)]]]))
             articles)

           (when
             (and
               (cmn/has-permission? app-atom "SiteAdmin:Help Center")
               (not (cmn/curact app-atom [:mobile?])))
             [:div.u-block-center.u-max-width-720.u-margin-top-40.u-text-center
              (buttons/button-web "Add New Article"
                (merge
                  (urlstate/href-props app-atom "admin/help" "addnew" {:categoryid id})
                  {:style :secondary
                   :size :default}))])]))
      (toaster/loading-overlay app-atom :web.help/category)]]))

(defmethod flow/render-screen :web.help/category [app-atom _]
  (website/screen-wrapper app-atom
    (help-category app-atom)
    {:pagetype :help
     :hidesearch true}))

(defmethod t/transition-open :web.help/category [app-atom _ {:keys [id name]}]
  (toaster/open-overlay app-atom :web.help/category)
  (comms/ajax-get :web.help/category
    {:help-category
     #:help-category
      {:id id
       :ent/display-name name}}))

(defmethod comms/receive :web.help/category [app-atom {:keys [help-category] :as e}]
  (swap! (cmn/process-cursor app-atom) assoc
    :help-category help-category)
  (toaster/close-overlay app-atom :web.help/category))